import React, { Component } from 'react'

export default class AriaMessage extends Component {
  constructor(props) {
    super(props)
    this.state = {
      message: ''
    }
  }

  componentDidMount() {
    setTimeout(()=>{ this.setState({ message: this.props.message }) }, 500)
    setTimeout(()=>{ this.setState({ message: '' }) }, 1000)
  }

  render() {
    return (
      <div className="aria-live-message" role="status" aria-live="assertive" aria-atomic="true">
        {this.state.message ? <span>{this.state.message}</span> : ''}
      </div>
    )
  }
}